export type SensorMonocolorVariantIconId = 'mono' | 'color';

const SENSOR_MONOCOLOR_ATTRIBUTE_CODE = 'sensor_monocolor';

/**
 * Maps a sensor monocolor option label to the ProductVariantPickerOption `id`
 * used with `showColor` (CSS modifier: `--circle-mono` / `--circle-color`).
 */
export function getSensorMonocolorVariantIconId(
  attributeCode: string,
  label: string
): SensorMonocolorVariantIconId | undefined {
  if (attributeCode !== SENSOR_MONOCOLOR_ATTRIBUTE_CODE) {
    return undefined;
  }

  const normalizedLabel = label.trim().toLowerCase();

  if (normalizedLabel === 'mono') {
    return 'mono';
  }

  if (
    normalizedLabel === 'color' ||
    normalizedLabel === 'colour' ||
    normalizedLabel === 'farbe'
  ) {
    return 'color';
  }

  return undefined;
}

const SENSOR_MONOCOLOR_SORT_ORDER: Record<
  SensorMonocolorVariantIconId,
  number
> = {
  mono: 0,
  color: 1
};

/**
 * Returns a stable sort index for sensor monocolor options (mono before color).
 */
export function getSensorMonocolorVariantSortIndex(
  attributeCode: string,
  label: string
): number | undefined {
  const iconId = getSensorMonocolorVariantIconId(attributeCode, label);

  if (!iconId) {
    return undefined;
  }

  return SENSOR_MONOCOLOR_SORT_ORDER[iconId];
}
